// IMPORTS
// Pinia
import { defineStore } from 'pinia';
/**
 * Authenticate State
 *  data: Theme data
 */
interface ThemeState {
  activeTheme: string;
}

/**
 * Theme Store
 */
export const useThemeStore = defineStore('Theme', {
  // Return the initial state of the store
  state: (): ThemeState => ({
    activeTheme: 'theme-adult'
  }),

  // Store Getters
  getters: {},
  // Store Actions
  actions: {
    load(activeTheme: string) {
      if (activeTheme) {
        this.activeTheme = activeTheme;
        return true;
      }
      return false;
    },
    /**
     * Reset the theme store to their initial state
     *
     * This is useful when the underlying data
     * is no longer valid or needs to be refreshed.
     */
    reset: function () {
      this.$reset();
    }
  }
});
